import React from "react"

interface DotsSelectProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onSelect"> {
    selected?: number | undefined
    length: number | undefined
    onSelect?: ((value: number) => void) | undefined
    dotStyle?: React.CSSProperties | undefined
    selectedDotStyle?: React.CSSProperties | undefined
}

const DOT_BUTTON_STYLE: React.CSSProperties = {
    backgroundColor: "transparent",
    padding: "8px",
    cursor: "pointer",
}

const DOT_STYLE: React.CSSProperties = {
    width: "24px",
    height: "24px",
    backgroundColor: "var(--color-neutral-300)",
    borderRadius: "var(--radius-5)",
}

const SELECTED_DOT_STYLE: React.CSSProperties = {
    backgroundColor: "var(--color-primary-700)",
}

const DotsSelect: React.FC<DotsSelectProps> = props => {
    const {selected, length = 0, selectedDotStyle, dotStyle, onSelect, ...otherProps} = props

    const dots = []
    for (let index = 0; index < length; index++) {
        dots.push(
            <Dot
                key={index}
                style={DOT_BUTTON_STYLE}
                {...(onSelect ? {onClick: () => onSelect(index)} : {})}
                dotStyle={
                    index === selected
                        ? {...DOT_STYLE, ...dotStyle, ...SELECTED_DOT_STYLE, ...selectedDotStyle}
                        : {...DOT_STYLE, ...dotStyle}
                }
            />,
        )
    }

    return <div {...otherProps}>{dots}</div>
}

interface DotProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    dotStyle?: React.CSSProperties | undefined
}

const Dot: React.FC<DotProps> = props => {
    const {style, dotStyle, ...otherProps} = props

    return (
        <button style={{...style}} {...otherProps}>
            <div style={dotStyle} />
        </button>
    )
}

export default DotsSelect
